import paginationFactory from 'react-bootstrap-table2-paginator';
import useServerTable from '../libs/useServerTable';
import React, {useEffect, useState} from "react";
import {Container, Jumbotron} from "react-bootstrap";
import {Link} from "react-router-dom";
import {host, socket} from "../libs/webRTC";
import axios from "../libs/httpClient";
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';
import filterFactory, {dateFilter} from '../libs/filter/index';

export default function Statistic(props) {
    const table = useServerTable('failed', {}, {}, 'start');
    const db = table.rows;
    const columns =[
        { text: 'Токен', dataField: 'id', sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell"><Link to= {row['link']} > {cell} </Link></div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            },
        },
        { text: 'ФИО студента', dataField: 'name', sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell">{cell}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            },
        },
        { text: 'Начало сессии', dataField: 'start', sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell">{moment(cell).format('DD.MM.YY h:mm:ss a')}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            }
        },
        { text: 'Конец сессии', dataField: 'end', sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell">{moment(cell).format('DD.MM.YY h:mm:ss a')}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            }
        },
        { text: 'Нажимал на кнопку "Начать запись"', dataField: 'startButton',sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell">{cell}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            }
        },
        { text: 'Ошибка kurento', dataField: 'kurentoFailed',sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell">{cell}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            },
        },
        { text: 'Количество нажатий на кнопку', dataField: 'countButton', sort: true,
            formatter:(cell, row, rowIndex, extraData) =>
                (<div class="table-cell">{cell}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center', cursor: "pointer",
                position: 'sticky', top: '0', backgroundColor: "white"};
            },
        }];
      
    
        function stat(){
            const total = table.summary.total || 0;
            const countUnpressedPressedButton = table.summary.unpressed || 0;
            const countBiggerThan1 = table.summary.failed || 0;
            const buttonСlickPercentage = total ? countUnpressedPressedButton / total * 100 : 0;
            const sessionFailedPercentage = total ? countBiggerThan1 / total * 100 : 0;
        return(
            <div>
                <div>Количество сессий: {total}</div>
                <div>Количество сессий где не была нажата кнопка: {countUnpressedPressedButton}</div>
                <div>Процент сессий где не была нажата кнопка: {buttonСlickPercentage.toFixed(2)}%</div>
                <div>Неудачных сессий: {countBiggerThan1}</div>
                <div>Процент неудачных сессий: {sessionFailedPercentage.toFixed(2)}%</div>
            </div>
        );}

        function synchronize(){
                axios.get(`${host}/failed/sessions/synchronize`).then((res)=>{
                    
                    alert(res.data);
                    window.location.reload();
                }).catch((error) =>{
                    alert(`Error!\n${error}`);
                });
        }

    return (<Jumbotron fluid>
                <Container>
                    <h1>Статистика</h1>
                    <p>{stat()}</p>
                    <button className="btn btn-lg btn-primary" onClick={synchronize}>Синхронизировать</button>
                    {table.error && <p role="alert">{table.error} <button onClick={table.reload}>Повторить</button></p>}
                    {table.loading && <p role="status">Загрузка...</p>}
                    <BootstrapTable data={db} keyField='id' columns={columns}
                        remote={{ pagination: true, filter: true, sort: true }} onTableChange={table.onTableChange}
                        defaultSorted={[{ dataField: 'start', order: 'desc' }]}
                        pagination={paginationFactory({ page: table.page, sizePerPage: table.limit, totalSize: table.total, sizePerPageList: [10, 25, 50, 100], showTotal: true })}/>
                </Container>
            </Jumbotron>
            );  
}

